import React from 'react';

import UniversityLogoImage from '../../../static/assets/utb-logo.png';

import { WrapperWithLink, UniversityImage } from './styles';

const UniversityLogo = () => {
  return (
    <WrapperWithLink href='https://www.utb.cz' target='_blank'>
      <UniversityImage src={UniversityLogoImage} alt='UTB logo' />
    </WrapperWithLink>
  );
};

export default UniversityLogo;
